var Parser = /** @class */ (function () {
    function Parser(breakpoints) {
        this.breakpoints = breakpoints || {
            sm: 576,
            md: 768,
            lg: 992,
            xl: 1200,
            xxl: 1600,
        };
    }
    Parser.prototype.create = function (parser, defaultOptions) {
        return new parser(this.breakpoints, defaultOptions);
    };
    return Parser;
}());
export default Parser;
//# sourceMappingURL=parser.js.map